<app-kiosk-header-atom
  *ngIf="logo()?.url as url"
  [logoImageUrl]="url"
  [displayLogo]="displayLogo()"
  [backgroundColor]="backgroundColor()"
  [backgroundImage]="backgroundImage()"
  [headerLandingText]="headerLandingText()"
  [displayLeavingSessionButton]="displayLeavingSessionButton()"
  [displayHomeButton]="displayHomeButton()"
  [buttonHomeText]="buttonHomeText()"
  [buttonBackgroundColor]="buttonBackgroundColor()"
  [buttonTextColor]="buttonTextColor()"
  [size]="size()"
></app-kiosk-header-atom>
